import * as React from 'react';

import { ControlledInputDate } from 'components';
import { useTranslation } from 'react-i18next';

const STARTDATE = 'startDate';

export const CampaignStartDate = ({
  ...props
}: {
  [key: string]: any;
}): JSX.Element => {
  const { t } = useTranslation();
  return (
    <ControlledInputDate
      label={t('startDate', 'Data startu')}
      name={STARTDATE}
      type='date'
      {...props}
    />
  );
};
